import { apiClient as api } from "./httpClient";

// Definição de senha por link (RN-005b) — endpoints anônimos por alias + token.
// Usado tanto pelo convite de primeiro acesso quanto pelo "esqueci minha senha".

export type PasswordSetupStatus = "valid" | "expired" | "used" | "revoked" | "invalid";

export interface PasswordSetupState {
  status: PasswordSetupStatus;
  clinicName: string | null;
  purpose: string; // "invite" | "reset"
}

export const passwordSetupService = {
  getState: async (alias: string, token: string): Promise<PasswordSetupState> => {
    const response = await api.get(
      `/password-setup/${encodeURIComponent(alias)}/${encodeURIComponent(token)}`);
    return response.data;
  },

  setPassword: async (alias: string, token: string, password: string): Promise<void> => {
    await api.post(
      `/password-setup/${encodeURIComponent(alias)}/${encodeURIComponent(token)}`,
      { password });
  },

  // "Esqueci minha senha": responde 204 exista a conta ou não — a tela nunca revela
  // se o email está cadastrado.
  forgotPassword: async (alias: string, email: string): Promise<void> => {
    await api.post(`/password-setup/${encodeURIComponent(alias)}/forgot`, { email });
  },
};
